import { formatJalaliDateTime } from "./dateFormat";
export const printPayroll = (payroll) => {
  const printWindow = window.open("", "_blank");
  if (!printWindow) return;

  const employeeValue = payroll?.employee_details?.name || "-";
  const shopValue = payroll?.shop_details?.name || "-";
  const currencyValue = payroll?.currency_details?.title || "-";
  const salaryValue = Number(payroll?.employee_details?.salary || 0).toFixed(2);
  const yearValue = payroll?.year || "-";
  const monthValue = payroll?.month || "-";
  const paymentDateValue = payroll?.payment_date
    ? formatJalaliDateTime(payroll.payment_date)
    : "-";
  const notesValue = payroll?.notes || "-";
  const previousAdvanceValue = Number(
    payroll?.previous_advance ?? payroll?.advance_previous_amount ?? 0
  ).toFixed(2);
  const advanceDeductionValue = Number(
    payroll?.advance_deduction ?? payroll?.deducted_advance_amount ?? 0
  ).toFixed(2);
  const remainingAdvanceValue = Number(
    payroll?.remaining_advance_balance ?? payroll?.advance_remaining_balance ?? 0
  ).toFixed(2);
  const advanceStatusValue = payroll?.advance_status || "Pending";
  const netSalaryValue = Number(
    payroll?.net_salary ??
      Math.max(
        Number(payroll?.employee_details?.salary || 0) -
          Number(payroll?.advance_deduction || 0),
        0
      )
  ).toFixed(2);
  const paymentAmountValue = Number(payroll?.amount || 0).toFixed(2);
  const remainingPaymentValue = Number(
    payroll?.remaining_payment_balance ??
      Math.max(Number(netSalaryValue) - Number(paymentAmountValue), 0)
  ).toFixed(2);
  const paymentStatusValue =
    payroll?.payment_status ||
    (Number(remainingPaymentValue) > 0 ? "Pending" : "Completed");
  const loadedOn = formatJalaliDateTime();

  const printContent = `
    <html>
      <head>
        <title>Payroll Receipt</title>
        <style>
          * { box-sizing: border-box; }
          body {
            margin: 0;
            padding: 28px;
            background: #f3f6fb;
            color: #0f172a;
            font-family: Arial, Helvetica, sans-serif;
          }
          .wrap {
            max-width: 840px;
            margin: 0 auto;
            background: #fff;
            border: 1px solid #d8e1ee;
            border-radius: 14px;
            overflow: hidden;
          }
          .print-toolbar {
            max-width: 840px;
            margin: 0 auto 12px;
            display: flex;
            justify-content: flex-end;
            gap: 10px;
          }
          .print-btn {
            border: none;
            border-radius: 8px;
            background: #0f4f8f;
            color: #fff;
            font-size: 13px;
            font-weight: 800;
            padding: 10px 18px;
            cursor: pointer;
          }
          .print-btn.secondary {
            background: #e2e8f0;
            color: #102a43;
          }
          .header {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            gap: 18px;
            padding: 24px 28px;
            background: #0f4f8f;
            color: #fff;
          }
          .brand { margin: 0 0 6px 0; font-size: 20px; font-weight: 800; }
          .subtitle { margin: 0; font-size: 12px; color: #dbeafe; }
          .receipt-box {
            text-align: right;
            min-width: 160px;
          }
          .receipt-title {
            margin: 0 0 6px 0;
            font-size: 18px;
            font-weight: 800;
          }
          .receipt-id { margin: 0; font-size: 11px; color: #dbeafe; }
          .body { padding: 22px 28px 26px; }
          .meta {
            display: grid;
            grid-template-columns: repeat(4, minmax(0, 1fr));
            gap: 10px;
            margin-bottom: 18px;
          }
          .meta-item {
            border: 1px solid #e1e8f2;
            background: #f8fafc;
            border-radius: 8px;
            padding: 10px 12px;
          }
          .label {
            color: #64748b;
            font-size: 10px;
            font-weight: 700;
            text-transform: uppercase;
            margin-bottom: 5px;
          }
          .value {
            color: #0f172a;
            font-size: 12px;
            font-weight: 700;
            line-height: 1.25;
            word-break: break-word;
          }
          .section-title {
            margin: 18px 0 10px;
            font-size: 12px;
            font-weight: 800;
            color: #102a43;
            text-transform: uppercase;
            letter-spacing: 0.04em;
          }
          .summary-grid {
            display: grid;
            grid-template-columns: repeat(3, minmax(0, 1fr));
            gap: 12px;
            margin-bottom: 18px;
          }
          .metric {
            border: 1px solid #d8e1ee;
            border-radius: 10px;
            padding: 14px;
            background: #fff;
          }
          .metric.primary {
            background: #eef6ff;
            border-color: #b8d8f5;
          }
          .metric .amount {
            font-size: 19px;
            font-weight: 800;
            color: #0f4f8f;
          }
          .status {
            display: inline-block;
            padding: 5px 10px;
            border-radius: 999px;
            background: ${paymentStatusValue === "Completed" ? "#dcfce7" : "#fef3c7"};
            color: ${paymentStatusValue === "Completed" ? "#166534" : "#92400e"};
            font-size: 11px;
            font-weight: 800;
          }
          .rows {
            border: 1px solid #e1e8f2;
            border-radius: 10px;
            overflow: hidden;
            margin-bottom: 18px;
          }
          .row {
            display: grid;
            grid-template-columns: 1fr 1fr;
            border-bottom: 1px solid #e1e8f2;
          }
          .row:last-child { border-bottom: none; }
          .cell {
            padding: 11px 14px;
            min-height: 42px;
          }
          .cell:nth-child(odd) { border-right: 1px solid #e1e8f2; }
          .notes {
            border: 1px solid #e1e8f2;
            border-radius: 10px;
            padding: 14px;
            background: #fbfdff;
            margin-bottom: 18px;
          }
          .footer {
            display: flex;
            justify-content: space-between;
            color: #64748b;
            font-size: 10px;
            border-top: 1px solid #e1e8f2;
            padding-top: 12px;
          }
          @media print {
            body { background: #fff; padding: 0; }
            .wrap { border: none; border-radius: 0; }
            .print-toolbar { display: none; }
          }
          @media (max-width: 720px) {
            body { padding: 12px; }
            .header, .footer { flex-direction: column; }
            .receipt-box { text-align: left; }
            .meta, .summary-grid { grid-template-columns: 1fr 1fr; }
            .row { grid-template-columns: 1fr; }
            .cell:nth-child(odd) { border-right: none; }
          }
        </style>
      </head>
      <body>
        <div class="print-toolbar">
          <button class="print-btn secondary" onclick="window.close()">Close</button>
          <button class="print-btn" onclick="window.print()">Print</button>
        </div>
        <div class="wrap">
          <div class="header">
            <div>
              <h1 class="brand">Tawakal Noorzai Trading Company</h1>
              <p class="subtitle">Payroll receipt and employee payment record</p>
            </div>
            <div class="receipt-box">
              <p class="receipt-title">Payroll Receipt</p>
              <p class="receipt-id">Receipt #${payroll?.id || "-"}</p>
            </div>
          </div>
          <div class="body">
            <div class="meta">
              <div class="meta-item"><div class="label">Employee</div><div class="value">${employeeValue}</div></div>
              <div class="meta-item"><div class="label">Branch</div><div class="value">${shopValue}</div></div>
              <div class="meta-item"><div class="label">Period</div><div class="value">${yearValue}-${monthValue}</div></div>
              <div class="meta-item"><div class="label">Payment Date</div><div class="value">${paymentDateValue}</div></div>
            </div>

            <div class="section-title">Payment Summary</div>
            <div class="summary-grid">
              <div class="metric">
                <div class="label">Salary</div>
                <div class="amount">${salaryValue} ${currencyValue}</div>
              </div>
              <div class="metric">
                <div class="label">Advance Deduction</div>
                <div class="amount">${advanceDeductionValue} ${currencyValue}</div>
              </div>
              <div class="metric primary">
                <div class="label">Net Salary</div>
                <div class="amount">${netSalaryValue} ${currencyValue}</div>
              </div>
              <div class="metric primary">
                <div class="label">Payment Amount</div>
                <div class="amount">${paymentAmountValue} ${currencyValue}</div>
              </div>
              <div class="metric">
                <div class="label">Remaining Payment</div>
                <div class="amount">${remainingPaymentValue} ${currencyValue}</div>
              </div>
              <div class="metric">
                <div class="label">Payment Status</div>
                <div class="value"><span class="status">${paymentStatusValue}</span></div>
              </div>
            </div>

            <div class="section-title">Advance Details</div>
            <div class="rows">
              <div class="row">
                <div class="cell"><div class="label">Previous Advance</div><div class="value">${previousAdvanceValue} ${currencyValue}</div></div>
                <div class="cell"><div class="label">Remaining Advance</div><div class="value">${remainingAdvanceValue} ${currencyValue}</div></div>
              </div>
              <div class="row">
                <div class="cell"><div class="label">Advance Status</div><div class="value">${advanceStatusValue}</div></div>
                <div class="cell"><div class="label">Currency</div><div class="value">${currencyValue}</div></div>
              </div>
            </div>

            <div class="notes">
              <div class="label">Notes</div>
              <div class="value">${notesValue === "-" ? "No notes available for this payroll record." : notesValue}</div>
            </div>

            <div class="footer">
              <span>Generated on ${loadedOn}</span>
              <span>Payroll dashboard print view</span>
            </div>
          </div>
        </div>
      </body>
    </html>
  `;
  printWindow.document.write(printContent);
  printWindow.document.close();
  printWindow.focus();
  printWindow.print();
};
